export enum TimeAndAttendanceStep {
  Form,
  Confirm,
}
